import { Injectable } from '@angular/core';
import { PaymentCourtFeesApiModel } from '../../models/about-court-fee/about-court-fees';
import { PaymentCourtFeesModel } from '../../view-models/about-court-fees';


import { Mapper } from '../mapper';
@Injectable({
    providedIn: 'root'
})
export class PaymentCoustFeesMapper implements Mapper<PaymentCourtFeesApiModel, PaymentCourtFeesModel>  {
    constructor(

    ) { }
    mapForm(param: PaymentCourtFeesApiModel): PaymentCourtFeesModel {
        {
            const data = new PaymentCourtFeesModel

            data.caseId = param.caseId
            data.billId = param.billId
            data.refCode = param.refCode
            data.paymentRefCode1 = param.payCode1
            data.paymentRefCode2 = param.payCode2
            data.payDate = param.payDate
            data.fees = param.payToTal
            data.payUserName = param.payUserName
            data.email = param.email
            data.courtName = param.courtName
            data.bankAgency = null!
            data.courtBankAccount = null!
            data.payComplete = null!
            data.payCompleteDate = null!
            data.payInNo = param.payInvNo
            data.genQrCode = param.genQrCode
            data.amount = param.amount
            data.payCode = param.payCode
            data.title = param.title
            data.name1 = param.name1
            data.name2 = param.name2
            return data
        }
    }
    mapTo(param: PaymentCourtFeesModel): PaymentCourtFeesApiModel {
        return null!
    }

} 